module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"iw-content\">\n  <div class=\"location-type location-type-")
    ; __append(escapeFn( location.location_friendly_type.split(' ').join('_').toLowerCase() ))
    ; __append("\">\n    ")
    ; __append(escapeFn( location.location_friendly_type ))
    ; __append("\n  </div>\n  <h5 style=\"margin-top: 5px;\">")
    ; __append(escapeFn( location.human_name ))
    ; __append("</h5>\n  <table class=\"condensed-table\">\n    <tr>\n      <td>\n        ")
    ; __append(escapeFn( location.street_address ))
    ; __append("\n      </td>\n    </tr>\n    <tr>\n      <td>\n        ")
    ; __append(escapeFn( location.city ))
    ; __append(escapeFn( map.state_string(location) ))
    ; __append(" ")
    ; __append(escapeFn( location.postal_code ))
    ; __append("\n      </td>\n    </tr>\n  </table>\n  ")
    ;  if (location.total_spaces > 0) { 
    ; __append("\n    <h5>Spaces: ")
    ; __append(escapeFn( location.total_spaces ))
    ; __append("</h5>\n  ")
    ;  } 
    ; __append("\n  ")
    ;  if (location.hours) { 
    ; __append("\n    <h5>Hours: ")
    ; __append(escapeFn( location.hours ))
    ; __append("</h5>\n  ")
    ;  } 
    ; __append("\n  ")
    ;  if (location.min_kiosk_hourly_parking_rate > 0) { 
    ; __append("\n    <h5>\n      Cost:\n      $")
    ; __append(escapeFn( show_min_max_currency(location.min_kiosk_hourly_parking_rate, location.max_kiosk_hourly_parking_rate) ))
    ; __append("/hour\n    </h5>\n  ")
    ;  } 
    ; __append("\n  ")
    ;  if (location.min_kiosk_work_hours_parking_rate > 0) { 
    ; __append("\n    <h5>\n      Working Hours Cost:\n      $")
    ; __append(escapeFn( show_min_max_currency(location.min_kiosk_work_hours_parking_rate, location.max_kiosk_work_hours_parking_rate) ))
    ; __append("/hour\n    </h5>\n  ")
    ;  } 
    ; __append("\n  ")
    ;  if (location.min_kiosk_maximum_duration > 0) { 
    ; __append("\n    <h5>\n      Max Duration:\n      ")
    ; __append(escapeFn( show_min_max(location.min_kiosk_maximum_duration, location.max_kiosk_maximum_duration) ))
    ; __append(" days\n    </h5>\n  ")
    ;  } 
    ; __append("\n  ")
    ;  if (location.min_base_cost > 0) { 
    ; __append("\n    <h5>\n      Cost:\n      $")
    ; __append(escapeFn( show_min_max_currency(location.min_base_cost, location.max_base_cost) ))
    ; __append("/hour\n    </h5>\n  ")
    ;  } 
    ; __append("\n  ")
    ;  if (location.min_expired_cost > 0) { 
    ; __append("\n    <h5>\n      Expired Cost:\n      $")
    ; __append(escapeFn( show_min_max_currency(location.min_expired_cost, location.max_expired_cost) ))
    ; __append("/hour\n    </h5>\n  ")
    ;  } 
    ; __append("\n  ")
    ;  if (location.min_max_stay_days > 0) { 
    ; __append("\n    <h5>\n      Max Duration:\n      ")
    ; __append(escapeFn( show_min_max(location.min_max_stay_days, location.max_max_stay_days) ))
    ; __append(" days\n    </h5>\n  ")
    ;  } 
    ; __append("\n  ")
    ;  if (location.max_access_zone > 0) { 
    ; __append("\n    <a href=\"#\" onclick=\"jQuery('#limited-access').dialog({modal: true});\">(limited access)</a>\n  ")
    ;  } 
    ; __append("\n  ")
    ;  if (location.map_notes != "") { 
    ; __append("\n    <i>")
    ; __append(escapeFn( location.map_notes ))
    ; __append("</i>\n  ")
    ;  } 
    ; __append("\n</div>\n")
  }
  return __output;

}